export default __webpack_public_path__ + "static/media/fluidos-mobile-01.8b56b7cd.jpg";